import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Header, Content } from '~/components/modals/Modal';
import StripeElements from '~/components/StripeElements';

import PaymentForm from '../PaymentForm';

import * as S from './UpdateCardModal.styled';

const UpdateCardModal = ({ className }) => {
  const { t } = useTranslation();

  return (
    <S.Container className={className} data-testid="UpdateCardModal">
      <Header>{t('updateCardModal.title', 'Update card')}</Header>
      <Content>
        <S.FormField label={t('updateCardModal.cardFieldLabel', 'Enter new card')}>
          <StripeElements>
            <PaymentForm forceAdd updateDefaultCard />
          </StripeElements>
        </S.FormField>
      </Content>
    </S.Container>
  );
};

UpdateCardModal.defaultProps = {
  className: null,
};

UpdateCardModal.propTypes = {
  className: PropTypes.string,
};

export default UpdateCardModal;
